import { Identity } from "../../schema/types/identity/entity";
import { linksOf } from "../../services/cpln";
import { parseLink } from "../../utils/linkParser/linkParser";

export interface IdentityTableItem extends Identity {
  selfLink: string;
  gvc: string;
}

interface GetIdentityTableItemProps {
  link?: string;
  name?: string;
  item?: Identity;
}
export function getIdentityTableItem({ link, name, item }: GetIdentityTableItemProps): IdentityTableItem {
  if (item) {
    const selfLink = linksOf(item).self!;
    const parsed = parseLink(selfLink, { useInputCtx: true });

    return {
      ...item,
      selfLink: selfLink,
      gvc: parsed.gvc || "",
    };
  }

  if (link) {
    const parsed = parseLink(link, { useInputCtx: true });

    return {
      kind: "identity",
      name: parsed.name,
      selfLink: link,
      gvc: parsed.gvc || "",
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      id: "",
      lastModified: "",
      tags: {},
      version: 1,
    };
  }

  // assume name
  return {
    kind: "identity",
    name: name!,
    selfLink: `TODO test if this breaks`,
    gvc: "",
    links: [],
    created: "",
    description: "",
    id: "",
    lastModified: "",
    tags: {},
    version: 1,
  };
}

export const STORAGE_KEY_IDENTITY_LIST_LIMIT_TO_CONTEXT_GVC = "STORAGE_KEY_IDENTITY_LIST_LIMIT_TO_CONTEXT_GVC";
